type InputData = Array<Record<string, any>>

// Format numeric values preserving original precision
const formatNumericValue = (value: any): any => {
  if (value === null || value === undefined || value === '') {
    return ''
  }

  if (Array.isArray(value)) {
    return value.map(formatNumericValue).join(', ')
  }

  if (typeof value === 'object') {
    return JSON.stringify(value)
  }

  // Handle strings that might be numbers
  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (/^-?\d*\.?\d+$/.test(trimmed)) {
      const numValue = parseFloat(trimmed)
      return numValue
    }
    return value
  }

  if (typeof value === 'number') {
    return value
  }

  return String(value)
}

export function jsonToCsv(items: InputData, headers: Array<string>): string {
  if (items.length === 0) {
    return ''
  }

  const headerKeys = Object.keys(items[0])

  const escapeValue = (value: any): string => {
    if (value == null) return ''
    const formattedValue = formatNumericValue(value)
    const str = String(formattedValue)

    const shouldQuote = /[",\n\r]/.test(str)
    const escaped = str.replace(/"/g, '""')

    return shouldQuote ? `"${escaped}"` : escaped
  }

  const csvRows = [
    headers.join(','),
    ...items.map(item => {
      return headerKeys.map(key => escapeValue(item[key])).join(',')
    }),
  ]

  return csvRows.join('\n')
}
